import getFontPairs from './font-pairs';

const getFontPair = (state, fontPairId) => {
  const fontPairs = getFontPairs(state);

  return fontPairs.find((fontPair) => fontPair.id === fontPairId) || null;
};

export default getFontPair;
